import { IRiderLocationObject } from '../types'
import Paths from '../utils/paths'
import { serverApi } from '../utils/request'

class RiderLocationService {
  public createRiderLocation(riderId: string, location: IRiderLocationObject) {
    const path = Paths.riderLocation.indexForRider.replace(':riderId', riderId)
    return serverApi.post(path, location).then(({ data }) => data)
  }

  public updateRiderLocation(riderId: string, location: IRiderLocationObject) {
    const path = Paths.riderLocation.indexForRider.replace(':riderId', riderId)
    return serverApi.put(path, location).then(({ data }) => data)
  }

  public removeRiderLocation(id: string) {
    const path = Paths.riderLocation.removeById.replace(':id', id)
    return serverApi.delete(path).then(({ data }) => data)
  }
}

const riderLocationService = new RiderLocationService()

export { riderLocationService }



// WEBPACK FOOTER //
// ./src/services/RiderLocation.ts